import Cast from 'scratch-vm/src/util/cast';

class CIPDcMotor02Block {
    constructor() {

    }

    async dcMotorControl(dcMotor02, arg) {
        if (!dcMotor02) {
            return {
                result: false,
                error: '[Error] The dc motor 02 is not connected.',
            };
        }

        if (dcMotor02?.dcMotorControl) {
            dcMotor02.dcMotorControl(arg);
        }

        return new Promise(resolve => setTimeout(() => {
            resolve({
                result: true,
                error: null
            });
        }, 50)); // 0.05초 대기
    }

    async dcMotorWithTimeControl(dcMotor02, arg, second) {
        if (!dcMotor02) {
            return {
                result: false,
                error: '[Error] The dc motor 02 is not connected.',
            };
        }

        if (dcMotor02?.dcMotorControl) {
            dcMotor02.dcMotorControl(arg);
        }

        const sec = Cast.toNumber(second) * 1000;

        return new Promise(resolve => {
            setTimeout(() => {
                dcMotor02.dcMotorControl('Stop');
            }, sec);
            setTimeout(() => {
                resolve({
                    result: true,
                    error: null
                });
            }, sec + 50);
        }); // 0.05초 대기
    }
}

export default CIPDcMotor02Block;
